import type { ComputedRef } from 'vue'
import type { ShopModuleKey } from '~/utils/shopModules'

export function useShopModules() {
  const { settings, sellEnabled, returnsModuleEnabled, offersEnabled, generatorsEnabled } = useSiteSettings()

  const entitled = computed<Partial<Record<ShopModuleKey, boolean>>>(() => {
    try {
      const parsed = JSON.parse(settings.value.shop_addons || 'null') as Partial<Record<ShopModuleKey, boolean>> | null
      return parsed && typeof parsed === 'object' ? parsed : {}
    } catch {
      return {}
    }
  })

  // The first modules predate `shop_addons` and keep their legacy setting fallbacks.
  const legacy: Partial<Record<ShopModuleKey, ComputedRef<boolean>>> = {
    sell: sellEnabled,
    returns: returnsModuleEnabled,
    offers: offersEnabled,
    generators: generatorsEnabled,
  }

  function isEnabled(key: ShopModuleKey): boolean {
    const flag = legacy[key]
    if (flag) return flag.value
    return entitled.value[key] === true
  }

  return { isEnabled }
}
